<template>
  <div class="canvas-line-pic-question-view">
<!--    <div class="question-desc-view">{{questioninfo.desc}}</div>-->
    <template
      v-if="questionData.content_audio&&questionData.content_audio!=''&&questionData.content_audio!=null">
      <div class="question-play-btn"
           @click="playcontent(questionData.content_audio)">
        <div>听力材料</div>
      </div>
    </template>
    <div id="box" class="canvas-line-pic-question-info-view">
      <div class="canvas-lines-pic-question-content-info-view">
        <template v-for=" (topitem,index) in questioninfo.topcontents">
          <div :id="'linepictop'+index" class="pic-top-item-view" :data-sort="index" :data-choseitem="topitem"
               @click="clickTop($event)"
               :style="'background:url('+baseurl+topitem+');background-size:100% 100%;'"></div>
        </template>
      </div>
      <div class="canvas-lines-pic-question-content-info-view">
        <template v-for=" (bottomitem,index) in questioninfo.bottomcontents">
          <div :id="'linepicbottom'+index" class="pic-bottom-item-view" :data-sort="index" :data-choseitem="bottomitem"
               @click="clickBottom($event)"
               :style="'background:url('+baseurl+bottomitem+');background-size:100% 100%;'"></div>
        </template>
      </div>
      <canvas id="myCanvas"></canvas>
    </div>

    <audio ref="linepicmusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';

  export default {
    name: "canvaslinepicquestion",
    data() {
      return {
        baseurl: apiUtil.getBaseUrl(),
        questioninfo: {},
        showanswer: false,
        ctx: null,
        leftclick: [],
        rightclick: [],
        lineArr: [],
        ctx1: null,
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        showdesc: true,
        audiourl: "",
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false, 
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.linepicmusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData(this.questionData)
        setTimeout(() => {
          this.initCanvas()
        })
        
         
      },
      updateParse() {
         this.$emit("questionfinish", this.questioninfo)
      },
      initCanvas() {
        var c = document.getElementById("myCanvas");
        c.width = document.getElementById("box").clientWidth;
        c.height = document.getElementById("box").clientHeight;
        this.ctx = c.getContext("2d");
        if (this.questioninfo.useroption && this.questioninfo.useroption.length > 0) {
          this.drawuseroption()
        }
      },
      drawuseroption() {
        var topitems = document.getElementsByClassName("pic-top-item-view")
        var bottomitems = document.getElementsByClassName("pic-bottom-item-view")
        this.questioninfo.useroption.forEach(item => {
          var topitem = null
          var bottomitem = null
          for (var i = 0; i < topitems.length; i++) {
            if (topitems[i].dataset.choseitem == item[0]) {
              topitem = topitems[i]
            }
          }
          for (var j = 0; j < bottomitems.length; j++) {
            if (bottomitems[j].dataset.choseitem == item[1]) {
              bottomitem = bottomitems[j]
            }
          }
          var line = {
            linecolor: "black",
            index: [topitem.dataset.sort, bottomitem.dataset.sort],
            array: [topitem.dataset.choseitem, bottomitem.dataset.choseitem],
            left: {
              x: topitem.offsetLeft + topitem.offsetWidth / 2,
              y: topitem.offsetTop + topitem.offsetHeight - 5
            },
            right: {
              x: bottomitem.offsetLeft + bottomitem.offsetWidth / 2,
              y: bottomitem.offsetTop - 5
            }
          }
          var hasindex = this.ishavearr(this.lineArr, line)
          if (hasindex != -1) {
            this.lineArr.splice(hasindex, 1)
          } else {
            this.lineArr.push(line)
          }
          this.drawLine("myCanvas", this.ctx, this.lineArr)
        })
      },
      paraseData(questionData) {
        var questiondata = {};
        if (!questionData.useroption) {
          var topcontents = questionData.content.split("|")
          var bottomcontents = questionData.options.split("|")
          var answers = []
          var answerinfo = questionData.answer.split("&");
          answerinfo.forEach(item => {
            var answerinfoitem = item.split("|").sort();
            if (answerinfoitem.length > 2) {
              for (var i = 0; i < answerinfoitem.length - 1; i++) {
                var arr = [answerinfoitem[i], answerinfoitem[answerinfoitem.length - 1]]
                answers.push(arr)
              }
            } else {
              answers.push(answerinfoitem)
            }
          })
          questiondata.topcontents = this.randomSort(topcontents);
          questiondata.bottomcontents = this.randomSort(bottomcontents);
          questiondata.answers = answers;
          questiondata.content = questionData.content;
          questiondata.options = questionData.options;
          questiondata.question_type = questionData.question_type;
          questiondata.show_type = questionData.show_type;
          questiondata.desc = questionData.desc;
          questiondata.id = questionData.id;
          questiondata.exaquestion_id=questionData.exaquestion_id;
          questiondata.score=questionData.score;
          questiondata.content_audio = questionData.content_audio;
          questiondata.reading_time = questionData.reading_time;
          questiondata.answer_time = questionData.answer_time;
          
        } else {
          questiondata = questionData
        }
        return questiondata;
      },

      hasClass(elements, cName) {
        return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
      },
      addClass(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
        ;
      },
      removeClass(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
        }
      },
      clickTop(ev) {
          var isclick = false;
          var index = ev.target.dataset.sort
          var topitems = document.getElementsByClassName("pic-top-item-view")
          for (var i = 0; i < topitems.length; i++) {
            var topitem = topitems[i];
            if (i == index) {
              if (!this.hasClass(topitem, "click")) {
                this.addClass(topitem, "click")
                isclick = true;
              } else {
                this.removeClass(topitem, "click")
              }
            } else {
              this.removeClass(topitem, "click")
            }
          }
          var haschick = this.checkClick("pic-bottom-item-view");
          if (haschick && isclick) {
            this.isCanClick = true;
            this.checkArr();
          }
      },
      clickBottom(ev) {
          var isclick = false;
          var index = ev.target.dataset.sort
          var bottomitems = document.getElementsByClassName("pic-bottom-item-view")
          for (var i = 0; i < bottomitems.length; i++) {
            var bottomitem = bottomitems[i];
            if (i == index) {
              if (!this.hasClass(bottomitem, "click")) {
                this.addClass(bottomitem, "click")
                isclick = true;
              } else {
                this.removeClass(bottomitem, "click")
              }
            } else {
              this.removeClass(bottomitem, "click")
            }
          }
          var haschick = this.checkClick("pic-top-item-view");
          if (haschick) {
            this.checkArr()
          }
      },
      checkClick(dom) {
        var hasclick = false
        var items = document.getElementsByClassName(dom);
        for (var j = 0; j < items.length; j++) {
          var item = items[j];
          if (this.hasClass(item, "click")) {
            this.isCanClick = true;
            hasclick = true
          }
        }
        return hasclick;
      },
      checkArr() {
        var topitems = document.getElementsByClassName("pic-top-item-view")
        var bottomitems = document.getElementsByClassName("pic-bottom-item-view")
        var topitem = null
        var bottomitem = null
        for (var i = 0; i < topitems.length; i++) {
          if (this.hasClass(topitems[i], "click")) {
            topitem = topitems[i]

          }
        }
        for (var j = 0; j < bottomitems.length; j++) {
          if (this.hasClass(bottomitems[j], "click")) {
            bottomitem = bottomitems[j]
          }
        }
        var line = {
          linecolor: "black",
          index: [topitem.dataset.sort, bottomitem.dataset.sort],
          array: [topitem.dataset.choseitem, bottomitem.dataset.choseitem],
          left: {
            x: topitem.offsetLeft + topitem.offsetWidth / 2,
            y: topitem.offsetTop + topitem.offsetHeight - 5
          },
          right: {
            x: bottomitem.offsetLeft + bottomitem.offsetWidth / 2,
            y: bottomitem.offsetTop - 5
          }
        }
        var hasindex = this.ishavearr(this.lineArr, line)
        if (hasindex != -1) {
          this.lineArr.splice(hasindex, 1)
        } else {
          this.lineArr.push(line)
        }
        this.checkanswer()
        this.drawLine("myCanvas", this.ctx, this.lineArr)
        for (var i = 0; i < topitems.length; i++) {
          if (this.hasClass(topitems[i], "click")) {
            this.removeClass(topitems[i], "click")
          }
        }
        for (var j = 0; j < bottomitems.length; j++) {
          if (this.hasClass(bottomitems[j], "click")) {
            this.removeClass(bottomitems[j], "click")
          }
        }
      },
      drawLine(id, ctx, lineArr) {
        var c = document.getElementById(id);
        ctx.clearRect(0, 0, c.clientWidth, c.clientHeight);
        for (let i = 0; i < lineArr.length; i++) {
          ctx.beginPath();
          ctx.strokeStyle = lineArr[i].linecolor;
          ctx.lineCap = "round";
          ctx.lineWidth = "3";
          ctx.moveTo(lineArr[i].left.x + 5, lineArr[i].left.y + 5);
          ctx.lineTo(lineArr[i].right.x + 5, lineArr[i].right.y + 5);
          ctx.stroke();
        }
      },
      ishavearr(arr, value) {
        var flag = -1;
        if (arr.length > 0) {
          arr.forEach((item, index) => {
            if (item.left.x == value.left.x && item.left.y == value.left.y && item.right.x == value.right.x && item.right.y == value.right.y) {
              flag = index;
            }
          })
        }
        return flag
      },
      checkanswer() {
        var that = this;
        var useroption = []
        var isfinish = true
        if (this.lineArr.length > 0) {
          this.lineArr.forEach(item => {
            useroption.push(item.array)
          })
        } else {
          isfinish = false
        }
        this.questioninfo.useroption = useroption
        this.questioninfo.isfinish = isfinish
        this.$emit("questionfinish", this.questioninfo)
      },

      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.linepicmusic.src = audiourl;
        if (this.$refs.linepicmusic.paused) {
          this.$refs.linepicmusic.play()
          this.contentplay = true
        }
      },
      prev() {
        this.$refs.linepicmusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToPrev")
      },
      next() {
        this.$refs.linepicmusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToNext")
      },
      playend() {
        this.descplay = false;
        this.contentplay = false;
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .canvas-line-pic-question-view {
    width 100%;
    height 100%;
  }

  .canvas-line-pic-question-info-view {
    display flex;
    width 100%;
    height 75%;
    background #FFF;
    position relative;
    display flex;
    justify-content space-around;
    align-items center;
    flex-direction column;
  }

  .click {
    border 3px solid #5874F8 !important;
  }

  .redbord {
    border 3px solid #FF4276 !important;
  }

  .el-sentence-top-btn {
    width 38px;
    height 38px;
    background url("../../assets/img/el-up-btn.png");
    background-size 100% 100%;
  }

  .el-left-sentence-btn {
    position absolute;
    left 15px;
    display flex;
    flex-direction column;
  }

  .el-right-sentence-btn {
    position absolute;
    right 15px;
    display flex;
    flex-direction column;
  }

  .el-sentence-bottom-btn {
    width 38px;
    height 38px;
    background url("../../assets/img/el-down-btn.png");
    background-size 100% 100%;
  }

  .canvas-lines-pic-question-content-info-view {
    width 100%;
    height 50%;
    margin 10px auto;
    display flex;
    align-items center;
    justify-content space-around;
  }

  #myCanvas {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
    top: 0;
    left: 0;
  }

  .pic-bottom-item-view {
    width 180px;
    height 180px;
    border 3px solid #000;
    border-radius: 12px;
  }

  .pic-top-item-view {
    width 180px;
    height 180px;
    border 3px solid #000;
    border-radius: 12px;
  }

  .line-pic-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;

    .line-pic-finish-btn {
      width 50%;
      height 72px;
      font-size 36px;
      position absolute;
      left 25%;
      bottom 30px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }

    .line-pic-finish-view {
      width 100%;
      height 90px;
      display flex;
      position absolute;
      bottom 0;
    }

    .line-pic-answer-right-bottom-view img {
      margin-right 15px;
    }

    .line-pic-answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 36px;
      background #92C761;
    }

    .line-pic-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .line-pic-answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 36px;
        background #F45578;
      }

      .line-pic-answer-wrong-bottom-view img {
        margin-right 15px;
      }
    }
  }

  .line-pic-show-answer-btn {
    font-size 24px;
    color #fff;
    padding 0 15px;
    display flex;
    height 100%;
    flex-direction column;
    justify-content center;
    align-items center;
    background #92C761;
  }

  .line-pic-show-answer-dialog {
    width 100%;
    height 100%;
    position fixed;
    top 0;
    left 0;
    background #65d67a;
    z-index 2000;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
  }

  .close-answer-dialog {
    background url("../../assets/img/answer-close-bg.png")
    background-size 100% 100%;
    width 180px;
    height 180px;
    position absolute;
    left -90px;
    top -90px;
    z-index 11;
  }

  .line-pic-show-answer-content-view {
    width 88.5%;
    height 71.1%;
    background #fff;
    border-radius 12px;
    position relative;
  }

  .dialog-toast-text {
    margin-top 24px;
    font-size 36px;
    color #131313;
    font-weight bold;
  }

  .show-answer-content-info {
    width 50%;
    height 96%;
    margin 1% auto;
    overflow-y auto;
    font-size 36px;
    text-align left;
    line-height 50px;
  }

  @media screen and (max-width: 1600px) {
    .canvas-line-pic-question-info-view {
      display flex;
      width 88.54%;
      height 75%;

    }

    .prev-btn {
      position absolute;
      left 1%;
      top 50%;
      font-size 24px;
    }

    .next-btn {
      position absolute;
      right 1%;
      top 50%;
      font-size 24px;
    }

    .line-pic-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .line-pic-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
        border-radius 36px;
        background #5777FF;
        color #fff;
      }

      .line-pic-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        justify-content center;
        align-items center;
        font-size 24px;
        color #F5C55D;
        bottom 0;

        .line-pic-answer-wrong-bottom-view {
          font-size 24px;
        }

        .line-pic-answer-right-bottom-view {
          font-size 24px;
        }
      }

      .line-pic-finish-view img {
        width: 40px;
        height 40px;
        background-size 100% 100%;
      }

      .line-pic-show-answer-btn {
        font-size 18px;
      }

      .line-pic-show-answer-btn img {
        width 20px;
        height 20px;
      }
    }

    .pic-bottom-item-view {
      width 120px;
      height 120px;
      border 3px solid #000;
      border-radius: 12px;
    }

    .pic-top-item-view {
      width 120px;
      height 120px;
      border 3px solid #000;
      border-radius: 12px;
    }
  }

  @media screen and (max-width: 1600px) {
    .canvas-line-pic-question-info-view {
      display flex;
      width 88.54%;
      height 80%;
      background #FFF;
      position relative;
      justify-content space-around;
      align-items center;
      flex-direction column;

    }

    .prev-btn {
      position absolute;
      left 1%;
      top 50%;
      font-size 24px;
    }

    .next-btn {
      position absolute;
      right 1%;
      top 50%;
      font-size 24px;
    }

    .line-pic-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .line-pic-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
        border-radius 36px;
        background #5777FF;
        color #fff;
      }

      .line-pic-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        justify-content center;
        align-items center;
        font-size 24px;
        color #F5C55D;
        bottom 0;

        .line-pic-answer-wrong-bottom-view {
          font-size 24px;
        }

        .line-pic-answer-right-bottom-view {
          font-size 24px;
        }
      }

      .line-pic-finish-view img {
        width: 40px;
        height 40px;
        background-size 100% 100%;
      }

      .line-pic-show-answer-btn {
        font-size 18px;
      }

      .line-pic-show-answer-btn img {
        width 20px;
        height 20px;
      }
    }

    .pic-bottom-item-view {
      width 120px;
      height 120px;
      border 3px solid #000;
      border-radius: 12px;
    }

    .pic-top-item-view {
      width 120px;
      height 120px;
      border 3px solid #000;
      border-radius: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/canvaslinepicquestion.vue